import axios from 'axios';

const PartnerProfileService = {
  getBlocks(partnerId) {
    return axios.get(
      `/api/Profiles/${partnerId}?t=${new Date().getTime() + Math.random()}`,
    );
  },
  addBlock(details) {
    return axios.post(`/api/admin/profile/block`, details);
  },
  updateBlock(details) {
    return axios.put(`/api/admin/profile/block`, details);
  },
  addBlockData(blockInstanceId, details) {
    return axios.post(
      `/api/admin/profile/block/${blockInstanceId}/data`,
      details,
    );
  },
  updateBlockData(id, data) {
    return axios.put(`/api/admin/profile/block/data/${id}`, { data });
  },
  uploadFile(payload) {
    const formData = new FormData();
    formData.append('blockDataItemDataKey', payload.blockDataItemDataKey);
    formData.append('file', payload.file[0]);
    formData.append('uploadType', payload.type ? payload.type : 'file_upload');
    return axios.post(`/api/admin/profile/upload-file/${payload.blockDataItemDataKey}`, formData);
  },
  deleteBlockData(blockDataId) {
    return axios.delete(`/api/admin/profile/block/item/${blockDataId}`);
  },
  orderBlocks(partnerId, blocks) {
    return axios.put(`/api/admin/profile/reorder-blocks/${partnerId}`, blocks);
  },
  getContentBlock(blockId) {
    return axios.get(`/api/admin/profile/block/${blockId}`);
  },
  deleteBlock(blockId) {
    return axios.delete(`/api/admin/profile/block/${blockId}`);
  },
  addItemBlockItem(blockId, item) {
    return axios.post(`/api/admin/profile/block`, item);
  },
  deleteBlockItem(blockItemId) {
    return axios.delete(`/api/admin/profile/block/item/${blockItemId}`);
  },
};

export default PartnerProfileService;
